export const DUY_VE_YAZ_PREVIEW_PATH = '/admin/mini-tasks/duy-ve-yaz-preview';

export function isDuyVeYazPreviewEnabled(env) {
  if (env) return env.NODE_ENV === 'development' || env.REACT_APP_DUY_VE_YAZ_PREVIEW === 'true';
  return process.env.NODE_ENV === 'development' || process.env.REACT_APP_DUY_VE_YAZ_PREVIEW === 'true';
}

// No I/i: Turkish case distinctions are deliberately outside this preview pool.
export const PREVIEW_WORDS = Object.freeze(['EL', 'AL', 'AT', 'BAL', 'TOP', 'MASA', 'ELMA', 'KALEM', 'ARABA', 'KOL', 'KUTU']);
export const DEFAULT_THRESHOLDS = Object.freeze({ match: 0.85, mismatch: 0.90 });

export function evaluateRecognition(expected, text, confidence, thresholds = DEFAULT_THRESHOLDS) {
  if (!PREVIEW_WORDS.includes(expected)) return 'uncertain';
  return evaluateHandwritingRecognition(expected, text, confidence, thresholds);
}

// Shared blind OCR comparison; the laboratory retains its original word pool.
export function evaluateHandwritingRecognition(expected, text, confidence, thresholds = DEFAULT_THRESHOLDS) {
  if (!/^[A-HJ-Z]+$/.test(expected)) return 'uncertain';
  // Preserve every non-space character. Never strip accents, punctuation or I/ı.
  const raw = String(text || '').normalize('NFC').trim().replace(/\s+/g, ' ');
  if (!/^[A-HJ-Za-hj-z]+$/.test(raw) || !Number.isFinite(confidence) || confidence < 0 || confidence > 1) return 'uncertain';
  const normalized = raw.toUpperCase();
  if (normalized === expected) return confidence >= thresholds.match ? 'correct' : 'uncertain';
  return confidence >= thresholds.mismatch ? 'retry' : 'uncertain';
}
